export const REQUEST = 'Admin/Companies/REQUEST';
export const SUCCESS = 'Admin/Companies/SUCCESS';
export const ERROR = 'Admin/Companies/ERROR';

export const SET = 'Admin/Companies/SET';
export const ADDED = 'Admin/Companies/ADDED';
export const UPDATED = 'Admin/Companies/UPDATED';
